var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "nti-promotion__campaign-card" }, [
    _c("a", { attrs: { href: _vm.card.link } }, [
      _c("div", {
        staticClass: "nti-promotion__campaign-card__image",
        style: {
          background: `linear-gradient(0deg, rgba(38, 48, 56, 0.85), rgba(38, 48, 56, 0.85)), no-repeat center url(${_vm.card.imageUrl})`,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nti-promotion__campaign-card__content-container" },
        [
          _c("h3", { staticClass: "nti-promotion__campaign-card__title" }, [
            _vm._v(_vm._s(_vm.card.title)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nti-promotion__campaign-card__line" }),
          _vm._v(" "),
          _c("p", { staticClass: "nti-promotion__campaign-card__text" }, [
            _vm._v(_vm._s(_vm.card.messageShort)),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }